import React from 'react'
import InputMask from 'react-input-mask'
import {
  Grid,
  TextField,
  Typography,
  Select,
  MenuItem,
  FormControlLabel,
  Checkbox,
  Link,
} from '@material-ui/core'
import BaseDialog from './general/BaseDialog'
import { withStyles } from '@material-ui/core'
import { styles } from '../styles/js/baseDialog'
import { pages } from '../constants/pages'

const DialogBusinessComponent = ({
  classes,
  dialog,
  setDialog,
  formState,
  setFormState,
  create,
  statusRequestCreateEstabelecimento,
}) => {
  return (
    <BaseDialog
      dialog={dialog}
      setDialog={setDialog}
      title={'Cadastrar meu negócio'}
      description={'Preencha os campos abaixo para cadastrar seu negócio.'}
      actionTitle={'Cadastrar'}
      actionStatusRequest={statusRequestCreateEstabelecimento.isLoading}
      secondaryActionTitle={null}
      handleAction={() => create(formState)}
      handleSecondaryAction={null}
      disabledAction={
        !formState.nome ||
        !formState.bairro ||
        !formState.cidade ||
        !formState.aceito ||
        !formState.cnpj ||
        !formState.segmento ||
        !formState.telefone ||
        !formState.atendendoComo ||
        !formState.email
      }
      slug={'filtrar'}
      fullWidth={true}
      maxWidth={'sm'}
    >
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Typography variant='h6' className={classes.label}>
            Qual é o nome do estabelecimento?{' '}
            <span style={{ color: 'red', fontSize: '0.8em' }}>
              (campo obrigatório)
            </span>
          </Typography>

          <TextField
            id='nome'
            name='nome'
            value={formState.nome || ''}
            onChange={(event) =>
              setFormState({
                ...formState,
                nome: event.target.value,
              })
            }
            placeholder={'Exemplo: Padaria da Dulcinéia'}
            variant='outlined'
            margin='none'
            fullWidth
            autoComplete='off'
            required
          />
        </Grid>

        <Grid item xs={12}>
          <Typography variant='h6' className={classes.label}>
            Qual é o CNPJ do estabelecimento?{' '}
            <span style={{ color: 'red', fontSize: '0.8em' }}>
              (campo obrigatório)
            </span>
          </Typography>

          <InputMask
            mask='99.999.999/9999-99'
            maskChar=' '
            value={formState.cnpj || ''}
            onChange={(event) =>
              setFormState({
                ...formState,
                cnpj: event.target.value,
              })
            }
          >
            {() => (
              <TextField
                id='cnpj'
                name='cnpj'
                placeholder={'Exemplo: 60.896.848/0001-72'}
                variant='outlined'
                margin='none'
                fullWidth
                autoComplete='off'
                required
              />
            )}
          </InputMask>
        </Grid>

        <Grid item xs={12}>
          <Typography variant='h6' className={classes.label}>
            Qual é o segmento do estabelecimento?{' '}
            <span style={{ color: 'red', fontSize: '0.8em' }}>
              (campo obrigatório)
            </span>
          </Typography>

          <Select
            id='segmento'
            name='segmento'
            value={formState.segmento || ''}
            onChange={(event) =>
              setFormState({
                ...formState,
                segmento: event.target.value,
              })
            }
            variant='outlined'
            margin='none'
            fullWidth
            autoComplete='off'
          >
            {pages[0].segmentos
              .sort((a, b) => (a.nome > b.nome ? 1 : b.nome > a.nome ? -1 : 0))
              .map((option) => (
                <MenuItem key={option.id} value={option.id}>
                  {option.nome}
                </MenuItem>
              ))}
          </Select>
        </Grid>

        <Grid item xs={12}>
          <Typography variant='h6' className={classes.label}>
            Como você está atendendo?{' '}
            <span style={{ color: 'red', fontSize: '0.8em' }}>
              (campo obrigatório)
            </span>
          </Typography>

          <Select
            id='atendendoComo'
            name='atendendoComo'
            value={formState.atendendoComo || ''}
            onChange={(event) =>
              setFormState({
                ...formState,
                atendendoComo: event.target.value,
              })
            }
            variant='outlined'
            margin='none'
            fullWidth
            autoComplete='off'
          >
            <MenuItem key='0' value='1'>
              Apenas entrega (delivery)
            </MenuItem>
            <MenuItem key='1' value='2'>
              Apenas presencial (retirada)
            </MenuItem>
            <MenuItem key='3' value='3'>
              Entrega e presencial
            </MenuItem>
          </Select>
        </Grid>

        <Grid item xs={12}>
          <Typography variant='h6' className={classes.label}>
            Insira um telefone para contato:{' '}
            <span style={{ color: 'red', fontSize: '0.8em' }}>
              (campo obrigatório)
            </span>
          </Typography>

          <InputMask
            mask='(99) 9 9999 9999'
            maskChar=' '
            value={formState.telefone || ''}
            onChange={(event) =>
              setFormState({
                ...formState,
                telefone: event.target.value,
              })
            }
          >
            {() => (
              <TextField
                id='telefone'
                name='telefone'
                placeholder={'Exemplo: (41) 9 9999 9999'}
                variant='outlined'
                margin='none'
                fullWidth
                autoComplete='off'
                required
              />
            )}
          </InputMask>
        </Grid>

        <Grid item xs={12}>
          <Typography variant='h6' className={classes.label}>
            Insira um e-mail para contato:{' '}
            <span style={{ color: 'red', fontSize: '0.8em' }}>
              (campo obrigatório)
            </span>
          </Typography>

          <TextField
            id='email'
            name='email'
            value={formState.email || ''}
            onChange={(event) =>
              setFormState({
                ...formState,
                email: event.target.value,
              })
            }
            placeholder={'Exemplo: padaria@dulcineia.com.br'}
            variant='outlined'
            margin='none'
            fullWidth
            autoComplete='off'
            required
          />
        </Grid>

        <Grid item xs={12}>
          <Typography variant='h6' className={classes.label}>
            Qual é o endereço do seu negócio?{' '}
            <span style={{ color: 'red', fontSize: '0.8em' }}>
              (campo obrigatório)
            </span>
          </Typography>

          <TextField
            id='endereco'
            name='endereco'
            value={formState.endereco || ''}
            onChange={(event) =>
              setFormState({
                ...formState,
                endereco: event.target.value,
              })
            }
            placeholder={'Exemplo: Rua Mamoré, 753'}
            variant='outlined'
            margin='none'
            fullWidth
            autoComplete='off'
            required
          />
        </Grid>

        <Grid item xs={12}>
          <Typography variant='h6' className={classes.label}>
            Em qual bairro fica seu negócio?{' '}
            <span style={{ color: 'red', fontSize: '0.8em' }}>
              (campo obrigatório)
            </span>
          </Typography>

          <TextField
            id='bairro'
            name='bairro'
            value={formState.bairro || ''}
            onChange={(event) =>
              setFormState({
                ...formState,
                bairro: event.target.value,
              })
            }
            placeholder={'Exemplo: Mercês'}
            variant='outlined'
            margin='none'
            fullWidth
            autoComplete='off'
            required
          />
        </Grid>

        <Grid item xs={12}>
          <Typography variant='h6' className={classes.label}>
            E em qual cidade?{' '}
            <span style={{ color: 'red', fontSize: '0.8em' }}>
              (campo obrigatório)
            </span>
          </Typography>

          <TextField
            id='cidade'
            name='cidade'
            value={formState.cidade || ''}
            onChange={(event) =>
              setFormState({
                ...formState,
                cidade: event.target.value,
              })
            }
            placeholder={'Exemplo: Curitiba'}
            variant='outlined'
            margin='none'
            fullWidth
            autoComplete='off'
            required
          />
        </Grid>

        <Grid item xs={12}>
          <Typography variant='h6' className={classes.label}>
            Se desejar, insira um WhatsApp para contato:
          </Typography>

          <InputMask
            mask='(99) 9 9999 9999'
            maskChar=' '
            value={formState.whatsapp || ''}
            onChange={(event) =>
              setFormState({
                ...formState,
                whatsapp: event.target.value,
              })
            }
          >
            {() => (
              <TextField
                id='whatsapp'
                name='whatsapp'
                placeholder={'Exemplo: (41) 9 9999 9999'}
                variant='outlined'
                margin='none'
                fullWidth
                autoComplete='off'
                required
              />
            )}
          </InputMask>
        </Grid>

        <Grid item xs={12}>
          <Typography variant='h6' className={classes.label}>
            Se desejar, insira o Instagram do seu negócio:
          </Typography>

          <TextField
            id='instagram'
            name='instagram'
            value={formState.instagram || ''}
            onChange={(event) =>
              setFormState({
                ...formState,
                instagram: event.target.value,
              })
            }
            placeholder={'Exemplo: @rpcparana'}
            variant='outlined'
            margin='none'
            fullWidth
            autoComplete='off'
          />
        </Grid>

        <Grid item xs={12}>
          <Typography variant='h6' className={classes.label}>
            Se desejar, insira o Facebook do seu negócio:
          </Typography>

          <TextField
            id='facebook'
            name='facebook'
            value={formState.facebook || ''}
            onChange={(event) =>
              setFormState({
                ...formState,
                facebook: event.target.value,
              })
            }
            placeholder={'Exemplo: https://facebook.com/rpcparana'}
            variant='outlined'
            margin='none'
            fullWidth
            autoComplete='off'
          />
        </Grid>

        <Grid item xs={12}>
          <Typography variant='h6' className={classes.label}>
            Se desejar, indique o site do seu negócio:
          </Typography>

          <TextField
            id='site'
            name='site'
            value={formState.site || ''}
            onChange={(event) =>
              setFormState({
                ...formState,
                site: event.target.value,
              })
            }
            placeholder={'Exemplo: https://www.rpc.com.br'}
            variant='outlined'
            margin='none'
            fullWidth
            autoComplete='off'
          />
        </Grid>

        <Grid item xs={12}>
          <FormControlLabel
            control={
              <Checkbox
                checked={formState.aceito}
                onChange={(event) =>
                  setFormState({
                    ...formState,
                    aceito: event.target.checked,
                  })
                }
                name='aceito'
              />
            }
            label='Declaro que li e aceito o termo de uso'
          />
          <Typography variant='h6' className={classes.label}>
            <a
              href='http://cdn-static.rpc.com.br/bem_aqui_termo_de_uso_e_outras_avencas.pdf'
              target='_blank'
            >
              Clique aqui para ler o termo de uso
            </a>
          </Typography>
        </Grid>
      </Grid>
    </BaseDialog>
  )
}

export default withStyles(styles)(DialogBusinessComponent)
